import { PRODUCT_MODEL_CLASS_NAME, PRODUCT_MODEL_PLACEHOLDER } from 'models/daos/product/constants'
import { ARTICLE_MODEL_CLASS_NAME, ARTICLE_MODEL_PLACEHOLDER } from 'models/daos/article/constants'
import { CATEGORY_MODEL_CLASS_NAME, CATEGORY_MODEL_PLACEHOLDER } from 'models/daos/category/constants'
import { MOTIVATION_MODEL_CLASS_NAME, MOTIVATION_MODEL_PLACEHOLDER } from 'models/daos/motivation/constants'
import { ORDER_MODEL_CLASS_NAME, ORDER_MODEL_PLACEHOLDER } from 'models/daos/order/constants/index.cjs'
import { PAGE_MODEL_CLASS_NAME, PAGE_MODEL_PLACEHOLDER } from 'models/daos/page/constants'
import { PROMO_CODE_MODEL_CLASS_NAME, PROMO_CODE_MODEL_PLACEHOLDER } from 'models/daos/promo-code/constants'
import { MAILING_LIST_MODEL_CLASS_NAME, MAILING_LIST_MODEL_PLACEHOLDER } from 'models/daos/mailing-list/constants'
import { EMAIL_TEMPLATE_MODEL_CLASS_NAME, EMAIL_TEMPLATE_MODEL_PLACEHOLDER } from 'models/daos/email-template/constants'

/**
 * A mapping of classNAme to placeholder properties.
 * @type {Object}
 */
const MODEL_PLACEHOLDER = {
  [ARTICLE_MODEL_CLASS_NAME]: ARTICLE_MODEL_PLACEHOLDER,
  [CATEGORY_MODEL_CLASS_NAME]: CATEGORY_MODEL_PLACEHOLDER,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: EMAIL_TEMPLATE_MODEL_PLACEHOLDER,
  [MAILING_LIST_MODEL_CLASS_NAME]: MAILING_LIST_MODEL_PLACEHOLDER,
  [ORDER_MODEL_CLASS_NAME]: ORDER_MODEL_PLACEHOLDER,
  [PAGE_MODEL_CLASS_NAME]: PAGE_MODEL_PLACEHOLDER,
  [PRODUCT_MODEL_CLASS_NAME]: PRODUCT_MODEL_PLACEHOLDER,
  [PROMO_CODE_MODEL_CLASS_NAME]: PROMO_CODE_MODEL_PLACEHOLDER,
  [MOTIVATION_MODEL_CLASS_NAME]: MOTIVATION_MODEL_PLACEHOLDER
}

export {
  MODEL_PLACEHOLDER
}
